/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable camelcase */
import React, { useState } from 'react';
import GoalServices from '../../services/goal.services';
import CommentDeleteDialog from './coment-delete-conform';
import CkEditorComp from './CkEditorComp';
import { eventKeyConstants } from '../../utils/eventKey'
import { replaceLinkWithAnchor } from '../../utils/common';

const GoalSerivices = new GoalServices();

const RenderComment = ({
    firstname, lastname, comment, formattedDate, id, metric, picture, goal_id, canDelete, canEdit, comentActions
}) => {
    const [mouseOverId, mouseOverComment] = useState(0);
    const [openDeletePopup, setOpenDeletePopup] = useState<boolean>(false);
    const [activeEditor, setActiveEditor] = useState('');
    const [focusEditor, setFocusEditor] = useState(false);
    const newCommentEditor = `goal_comment_edit_editor_${goal_id}`;

    const editComment = (e, editorId) => {
        setActiveEditor(editorId);
        setFocusEditor(true);
    }
    const removeComment = () => {
        setActiveEditor('');
        setOpenDeletePopup(true);
    }
    const closeDeleteDialog = () => {
        setOpenDeletePopup(false);
        setTimeout(() => {
            document.getElementById(`del-comment-${id}`).focus();
            document.getElementById(`del-single-comment-${id}`).focus();
        }, 0);
    }
    const deleteColumn = () => {
        setOpenDeletePopup(false);
        const params = { gc_id: id, goal_id };
        if (canDelete) {
            const contentId = document.getElementById('content');
            showLoaderWidget(contentId);
            GoalSerivices.deleteComment(params).then((response) => {
                comentActions({ action: 'delete', id })
                removeLoader();
                const newEditor = CKEDITOR.instances[newCommentEditor];
                newEditor.focus();
            });
        }
    }
    const resetActiveEditor = (editorId) => {
        setActiveEditor('goal_comment_edit_editor');
    }
    const editorId = `goal_comment_edit_editor_${id}`;

    return (
        <div
            className="displayTable showMetric_comments_list width100 showEditDeleteIcon"
            role="listitem"
            tabIndex={0}
            id={`del-comment-${id}`}
        >
            <div
                className="displayRow postedGoalCommentBox1 goalcomment-widget-comp-box"
            >
                <div className="displayCell">
                    <img
                        alt=""
                        src={picture}
                        className="fitProfileImage goal-user-picture roundFramePhoto"
                        style={{ boxShadow: '0px 1px 1px #ccc' }}
                    />
                </div>
                <div className="displayCell goalCommentingSpace goalCommentCkEditor">
                    <div className="goal-comment-edit-wrapper">
                        {(editorId === activeEditor)
                            ? (
                                <CkEditorComp
                                    focusEditor={focusEditor}
                                    comentId={id}
                                    goalId={null}
                                    activeEditor={activeEditor}
                                    comment={comment}
                                    comentActions={comentActions}
                                    resetActiveEditor={resetActiveEditor}
                                />
                            )
                            : (
                                <div
                                    className="goal-comment-view modalParaText wrap"
                                    dangerouslySetInnerHTML={{ __html: replaceLinkWithAnchor(comment) }}
                                />
                            )}
                        {
                            typeof metric !== 'undefined' && metric.id && metric.m_data
                            && (
                                <div className="updated-metric-comment">
                                    { `Updated ${metric.name} to ${metric.m_data}`}
                                </div>
                            )
                        }
                    </div>
                    <div>
                        <div className="goal-comment-owner divInlineBlock">{`${firstname} ${lastname}`}</div>
                        <div className="goalTimeTextInPopUp divInlineBlock">
                            <div className="goal-comment-date modalParaText">&nbsp;{formattedDate}</div>
                        </div>
                    </div>
                    <div className="displayTable commentTools">
                        <div className="displayRow editRemoveWrapper">
                            <div className="goalCommenPencilTool displayCell">
                                <div
                                    role="button"
                                    className={
                                        canEdit
                                            ? 'edit-icon icon-outline-edit-18px-lightgrey removeBorder pointerCursor'
                                            : ''
                                    }
                                    style={{ display: editorId === activeEditor ? 'none' : '' }}
                                    onClick={(e) => editComment(e, editorId)}
                                    onKeyDown={(e) => {
                                        if (e.key === eventKeyConstants.ENTER || e.key === eventKeyConstants.SPACE) {
                                            e.preventDefault();
                                            editComment(e, editorId)
                                        }
                                    }}
                                    tabIndex={0}
                                    aria-label="Edit comment"
                                />
                            </div>
                            <div className="goalCommentCloseTool displayCell">
                                <div
                                    role="button"
                                    className={
                                        canDelete
                                            ? 'delete-icon icon-outline-close-18px-2 removeBorder pointerCursor'
                                            : ''
                                    }
                                    id={`del-single-comment-${id}`}
                                    style={{ display: editorId === activeEditor ? 'none' : '' }}
                                    onClick={(e) => removeComment()}
                                    onKeyDown={(e) => {
                                        if (e.key === eventKeyConstants.ENTER || e.key === eventKeyConstants.SPACE) {
                                            e.preventDefault();
                                            removeComment()
                                        }
                                    }}
                                    tabIndex={0}
                                    aria-labelledby={`del-comment-${id}`}
                                    aria-label="Delete comment"
                                />
                            </div>
                        </div>
                        {openDeletePopup && <CommentDeleteDialog
                            onClose={closeDeleteDialog}
                            onYes={deleteColumn}
                        />}
                    </div>
                    <span>&nbsp;</span>
                </div>
            </div>
        </div>
    );
}

export default RenderComment;
